/* App embed disabled; download Google Store widget only on desktop. */
(function(window,document){
  'use strict';
  if(!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches)return;
  function start(){
    if(!window.matchMedia('(min-width: 768px)').matches || document.getElementById('merchantWidgetScript'))return;
    var script=document.createElement('script');
    script.id='merchantWidgetScript';script.src='https://www.gstatic.com/shopping/merchant/merchantwidget.js';script.defer=true;
    script.addEventListener('load',function(){
      if(window.matchMedia('(min-width: 768px)').matches && window.merchantwidget){
        window.merchantwidget.start({position:'LEFT_BOTTOM',sideMargin:36,bottomMargin:36,merchant_id:'337131542'});
      }
    },{once:true});
    document.head.appendChild(script);
  }
  // Preserve the desktop badge without making the first paint wait for it.
  if(document.readyState==='complete')start();else window.addEventListener('load',start,{once:true});
})(window,document);
